















import { Contact } from "../models/Contact";
import InputField from "../core/Forms/InputField.vue";
import { ListParamApi } from "../api/ListParamApi";
import { Option } from "../models/Option";
import Multiselect from "vue-multiselect";
import { Config } from "../utils/Config";

export default {
    name: "ContactCoordonneesRoleEdit",
    components: { Multiselect, InputField },
    props: {
        label: String,
        coordonnees: Contact.Coordonnees,
    },
    data() {
        return {
            rolesOptions: [],
            selectedRoles: [],
            ListParamApi: new ListParamApi(),
            vueMultiselectParams: Config.vueMultiselectParams,
        };
    },
    created() {
        this.getRolesOptions();
    },
    methods: {
        getRolesOptions: function () {
            let self = this;
            self.ListParamApi.getAll({
                type: Option.EListParamType.role_contact,
            }).then(function (response) {
                self.rolesOptions = response;
                self.updateSelectedRoles();
            });
        },
        updateSelectedRoles: function () {
            let self = this;
            self.selectedRoles = _.chain(self.rolesOptions)
                .map(function (role) {
                    if (_.includes(self.coordonnees.roles, role.id)) {
                        return role;
                    }
                })
                .filter()
                .value();
        },
    },
    watch: {
        selectedRoles: {
            handler: function () {
                this.coordonnees.roles = _.map(this.selectedRoles, "id");
            },
        },
    },
};
